import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/warehouses.js';
import form from '../forms/warehouses.js';
import * as types from '../types.js';

/**
 * Corpo de tipo/endereço para POST/PATCH de armazém.
 * Em modo lógico, zera campos físicos no banco ao salvar.
 */
function warehouseTypePayload(data)
{
	const isPhysical = Number(data.warehouse_type) === 2;
	const t = (v) =>
	{
		if (!isPhysical)
			return null;
		if (v == null || String(v).trim() === '')
			return null;
		return String(v).trim();
	};
	let uf = t(data.address_state);
	if (uf && uf.length > 2)
		uf = uf.slice(0, 2).toUpperCase();
	else if (uf)
		uf = uf.toUpperCase();
	return {
		warehouse_type: isPhysical ? 2 : 1,
		address_zipcode: t(data.address_zipcode),
		address_street: t(data.address_street),
		address_number: t(data.address_number),
		address_complement: t(data.address_complement),
		address_city: t(data.address_city),
		address_state: uf && uf.length === 2 ? uf : null,
		phone: t(data.phone),
	};
}

const warehouses = function()
{

	let warehouses_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			let q = query || '';
			if (!/[?&]include_disabled=/.test(q))
				q += (q.includes('?') ? '&' : '?') + 'include_disabled=1';
			return await api.call(api.list_warehouses, q);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_warehouse, ...JSON.parse(id));
			if (_record && typeof _record === 'object')
			{
				_record.is_disabled =
					_record.is_disabled === true || _record.is_disabled === '1' ? '1' : '0';
				_record.warehouse_type =
					_record.warehouse_type != null && String(_record.warehouse_type) !== ''
						? String(_record.warehouse_type)
						: '1';
			}
			return _record;
		},
		async saveRecord(data, old_data)
		{
			const extra = warehouseTypePayload(data);
			if (old_data)
			{
				return await api.call(api.patch_warehouse, data.company_id, data.id, {
					name: data.name,
					is_disabled: data.is_disabled == '1' || data.is_disabled === true,
					...extra,
				});
			}
			return await api.call(api.insert_warehouse, data.company_id, {
				name: data.name,
				...extra,
			});
		},
	});
	
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Armazém', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do armazém' },
		{ index: 3, field: 'name', label: 'Nome', types: [], placeholder: '', title: 'Nome do armazém' },
		{ index: 4, field: 'warehouse_type', label: 'Tipo', types: [], placeholder: '', title: '1=lógico, 2=físico' },
		{ index: 5, field: 'is_disabled', label: 'Inativo', types: [], placeholder: '', title: 'Armazém inativo (não aparece em listagens operacionais)' },
	];

	warehouses_crud.run(
		'warehouses',
		'Armazéns',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		undefined,
		undefined,
		{ default_columns: '1,2,3,4,5' }
	);

};

export default warehouses;
